import "./App.css";
import Navbar from "./pages/Navbar";
import { LanguageProvider } from "./contexts/LanguageContext";
import Hero from "./components/Hero";
import About from "./components/About";
import { BrowserRouter } from "react-router-dom";
import Mission from "./components/Mission";
import Contact from "./components/Contact";

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
          <Navbar />
          <Hero />
          <About />
          <Mission />
          <Contact />
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
